// Saúde agregada de um Project (backend: project_overview_service).
// "healthy" exige verificação HTTP real; containers rodando = "operational".
const HEALTH = {
  healthy: { status: "healthy", label: "Saudável" },
  operational: { status: "online", label: "Operacional" },
  degraded: { status: "degraded", label: "Degradado" },
  down: { status: "down", label: "Fora do ar" },
  unknown: { status: "unknown", label: "Desconhecido" },
};

export const healthBadge = (health) => HEALTH[health] || HEALTH.unknown;

export const SERVICE_KIND_LABEL = {
  web: "Web", application: "Aplicação", other: "Outro", database: "Banco de dados", cache: "Cache", api: "API",
  worker: "Worker", queue: "Fila", proxy: "Proxy",
};

export const STACK_CLASS_LABEL = {
  APPLICATION: "Aplicação", PLATFORM_INTERNAL: "Plataforma interna", INFRASTRUCTURE: "Infraestrutura",
  SHARED_SERVICE: "Serviço compartilhado", UNKNOWN: "Não classificado",
};
